// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__La5t6","insightsList":"newBusinessInsightsMenu_insightsList__op7XT","active":"newBusinessInsightsMenu_active__2HzAg"};